import React, { useCallback, useEffect, useState } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  capitalize,
  filterById,
  getDuefromSuccessPayments,
  isPaymentMethodZelleOrPaypal,
  MethodValidation,
  NaNtoNumber,
  returnIGTF,
} from '../../../../assets/helpers/funciones';
import {
  paymentTypeOptions as paymentTypesOptions,
  paymentModalTypes,
  paymentType,
  planTypes,
} from '../../../../assets/helpers/options';
import {
  paymentsTableHeader,
  casheaPaymentsTableHeader,
} from '../../../../assets/helpers/tables.js';
import { PaymentsTable } from '../../../common/Tables/Tables';
import { bsBlocked } from '../../../../assets/helpers/const';
import { membershipCatalogService } from '../../../../services/membershipCatalogService';
import { paymentsService } from '../../../../services/paymentsService';
import { rateService } from '../../../../services/rateService';
import { productService } from '../../../../services/productService';
import { membershipService } from '../../../../services/membershipService';
import { currencyRateService } from '../../../../services/currencyRateService';
import authService from '../../../../services/authService';
import { notify } from '../../../../assets/helpers/toast';
import { salesRoles } from '../../../../assets/helpers/roles';
import { OderCardHeader } from './OrderComponents';
import { PaymentModal, EditPaymentModal } from '../../../common/Modals/Modals';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import './OrderComponent.scss';

export const ChangePaymentCard = (props) => {
  const { label, membership, paymentType, reloadMembership } = props;
  const [totalPrice, setTotalPrice] = useState(0);
  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [plansOptions, setPlansOptions] = useState([]);
  const [dollarRate, setDollarRate] = useState('');
  const [bsDisabled, setbsDisabled] = useState(true);
  const [creationDate, setCreationDate] = useState('');
  const [openPayModal, setOpenPayModal] = useState(false);
  const [fileUploaded, setFileUploaded] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [openEditPaymentModal, setOpenEditPaymentModal] = useState({
    isOpen: false,
    payment: '',
  });
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
    control,
  } = useForm({
    resolver: yupResolver(schemas.upgradeOrderForm()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    resetField: resetField2,
    watch: watch2,
    reset: reset2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.upgradeMembershipSchema()),
  });

  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5 },
    getValues: getValues5,
    setValue: setValue5,
    watch: watch5,
    reset: reset5,
    control: control5,
    setError: setError5,
    trigger: trigger5,
  } = useForm({
    resolver: yupResolver(
      schemas.changeTypePaymentDuesSchema(getDuefromSuccessPayments(membership))
    ),
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    setValue: setValue4,
    watch: watch4,
    reset: reset4,
    control: control4,
  } = useForm({
    resolver: yupResolver(schemas.editPaymentSchema()),
  });

  const getDollarRate = () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  let loadPaymentForms = (params) => {
    let payments = [];
    // lOOP through every payment method
    for (let i = 1; i <= parseInt(watch2('paymentMethods')); i++) {
      let data = {};

      if (i === 1 && params?.igtf1) {
        data.igtf = true;
      }
      if (i === 2 && params?.igtf2) {
        data.igtf = true;
      }
      let amount1IGTF = NaNtoNumber(parseFloat(watch2('amount1IGTF')));
      let amount1_2IGTF = NaNtoNumber(parseFloat(watch2('amount1_2IGTF')));
      let amount2IGTF = NaNtoNumber(parseFloat(watch2('amount2IGTF')));

      data.amountIGTF = parseFloat(params[`amount` + i]);

      // Add IGTF 1 and raise flag
      if (i === 1 && amount1IGTF > 0) {
        data.igtf = true;
        data.amountIGTF = amount1IGTF + parseFloat(params[`amount` + i]);
      }

      // Add IGTF 1 in 2 or 2 and raise flag
      if (i !== 1 && (amount1_2IGTF > 0 || amount2IGTF > 0)) {
        data.igtf = true;
        data.amountIGTF = amount2IGTF + parseFloat(params[`amount` + i]);

        if (watch2('mix')) {
          data.amountIGTF = data.amountIGTF + amount1_2IGTF;
        }
      }

      data.amountIGTF = data.amountIGTF?.toFixed(2);

      data.methodId = params[`method` + i.toString()];
      data.method = filterById(
        paymentMethods,
        params[`method` + i.toString()]
      ).name;
      data.reference = params[`reference` + i.toString()];
      data.transactionBatch = params[`transactionBatch` + i.toString()];
      data.totalAmount = Number(params[`amount` + i.toString()]);
      data.owner = params[`owner` + i.toString()];
      data.totalAmountInBsS = Number(params[`amountBsS` + i.toString()]);
      data.status = 'Pendiente';
      if (params?.['bank' + i.toString()])
        data.bank = params[`bank` + i.toString()];

      payments.push({
        ...data,
      });
    }

    // "REmove unwanted params from JSON"
    let words = [
      'method',
      'reference',
      'transactionBatch',
      'amount',
      'amountBsS',
      'paymentMethod',
      'igtf',
      'amountIGTF',
    ];
    for (const key in params) {
      for (var i = 0, ln = words.length; i < ln; i++) {
        if (key.indexOf(words[i]) !== -1) {
          delete params[key];
        }
      }
    }
    params.payments = payments;
    return params;
  };

  //* LOGICA PARA AUTOCOMPLETAR CUOTAS DE CASHEA

  const finalPrice = parseFloat(watch5('finalPrice')) || 0;

  // Crea una función que sume los valores de los pagos
  const sumPayments = useCallback(() => {
    let total = 0;
    const payments = [
      'paymentDuesAmount0',
      'paymentDuesAmount1',
      'paymentDuesAmount2',
      'paymentDuesAmount3',
      'paymentDuesAmount4',
      'paymentDuesAmount5',
    ];
    payments.forEach((payment) => {
      const value = parseFloat(watch5(payment)) || 0;
      total += value;
    });
    setTotalPrice(total);
  }, [watch5]);

  const firstPaymentDue = watch5('paymentDuesAmount0');
  const secondPaymentDue = watch5('paymentDuesAmount1');
  const thirdPaymentDue = watch5('paymentDuesAmount2');
  const fourthPaymentDue = watch5('paymentDuesAmount3');
  const fifthPaymentDue = watch5('paymentDuesAmount4');
  const sixthPaymentDue = watch5('paymentDuesAmount5');

  useEffect(() => {
    sumPayments();
  }, [
    sumPayments,
    firstPaymentDue,
    secondPaymentDue,
    thirdPaymentDue,
    fourthPaymentDue,
    fifthPaymentDue,
    sixthPaymentDue,
  ]);

  // useEffect(() => {
  //   fillThirdPayment();
  // }, [
  //   firstPaymentDue,
  //   secondPaymentDue,
  //   thirdPaymentDue,
  //   thirdPaymentDue,
  //   fourthPaymentDue,
  //   fifthPaymentDue,
  //   sixthPaymentDue,
  //   fillThirdPayment,
  // ]);

  const handleInputChange = async (index) => {
    let acumulated = 0;

    for (let i = 0; i < watch5('duesQuantity'); i++) {
      setError5(`paymentDuesAmount${index + 1}`, {
        type: 'custom',
        message: '',
      });

      if (i !== index + 1) {
        acumulated = acumulated + parseFloat(watch5(`paymentDuesAmount${i}`));
      }
    }

    let nextQuota = parseFloat(watch5('finalPrice')) - acumulated;

    if (nextQuota > 0) {
      setValue5(`paymentDuesAmount${index + 1}`, nextQuota.toFixed(2));
    } else {
      setError5(`paymentDuesAmount${index}`, {
        type: 'custom',
        message: 'La suma de las cuotas excede el monto de la deuda',
      });
      setError5(`casheaQuota${index + 1}`, {
        type: 'custom',
        message: 'La suma de las cuotas excede el monto de la deuda',
      });
    }
  };

  const handleDateChange = (e) => {
    setCreationDate(e);
    getDollarRateByDate(e);
  };

  const getDollarRateByDate = (date) => {
    let params = {
      currency: 'USD',
      date: moment(date).format('YYYY-MM-DD'),
      limit: 20,
    };

    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          setValue4(
            'amountBsS',
            (watch4('amount') * response?.data?.result[0]?.rate)?.toFixed(2)
          );
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => { });
    return true;
  };

  const handleEditPaymentModal = (payment) => {
    setOpenEditPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !openEditPaymentModal?.isOpen,
        payment: payment ? payment : '',
      };
    });

    if (payment) {
      setValue4('amount', payment?.totalAmount);
      setValue4('amountBsS', payment?.totalAmountInBsS?.toFixed(2));
      setValue4('method', payment?.methodId);
      setValue4('reference', payment?.reference);
      setValue4('referenceCashea', payment?.referenceCashea);
      let fecha = new Date(payment?.createdAt);
      setCreationDate(fecha?.setDate(fecha.getDate()));
    } else {
      reset4();
    }
  };

  const handleEditAmountChange = () => {
    setValue4('amountBsS', watch4('amount') * dollarRate);
  };

  const appendFile = (data) => {
    const formData = new FormData();
    formData.append('newCode', watch('newCode'));
    formData.append('amount', watch('amount'));
    formData.append('amountBsS', watch('amountBsS'));
    if (watch('km')) {
      formData.append('km', watch('km'));
    }
    if (watch('hasExtendedTow')) {
      formData.append('useExtendedTow', watch('hasExtendedTow'));
    }
    formData.append('paymentType', watch2('paymentType'));
    formData.append(
      'paymentStrategy',
      parseFloat(watch2('paymentMethods')) === 2 ? 'Pago mixto' : 'Pago único'
    );

    for (var i = 0; i < data?.payments.length; i++) {
      formData.append(`payments[${i}][amount]`, data?.payments[i].amountIGTF);
      formData.append(
        `payments[${i}][amountBsS]`,
        data?.payments[i].amountIGTF * dollarRate
      );

      formData.append(
        `payments[${i}][hasEvidence]`,
        fileUploaded[i] ? true : false
      );
      if (data?.payments[i]?.igtf && returnIGTF() > 0) {
        formData.append(`payments[${i}][igtf]`, data?.payments[i]?.igtf);
      }
      formData.append(`payments[${i}][method]`, data?.payments[i].method);
      formData.append(`payments[${i}][reference]`, data?.payments[i].reference);
      if (
        data?.payments[i]?.transactionBatch !== undefined &&
        data?.payments[i]?.transactionBatch !== ''
      ) {
        formData.append(
          `payments[${i}][transactionBatch]`,
          data?.payments[i]?.transactionBatch
        );
      }
      if (data?.payments[i]?.method === '646955f7fccc5f07cd2b8d48') {
        // for zelle payments
        formData.append(`payments[${i}][accHolder]`, data?.payments[i]?.owner);
      }
    }

    // Load as many files as payment methods we have
    if (
      fileUploaded.length !== parseFloat(watch2('paymentMethods')) &&
      parseFloat(watch2('paymentMethods')) > 0 &&
      MethodValidation(data?.payments, fileUploaded, paymentMethods)
    ) {
      notify('Ingrese comprobantes de pago', 'info');
      return null;
    }
    if (parseFloat(watch2('price'))) {
      let totalSum = 0;
      for (let i = 0; i < data?.payments.length; i++) {
        totalSum = totalSum + parseFloat(data?.payments[i].amount);
      }
      if (totalSum < parseFloat(watch2('price'))) {
        notify(
          'Monto a pagar por el cliente y suma de los pagos no coinciden',
          'info'
        );
        return null;
      }
    }

    for (let i = 0; i < parseInt(watch2('paymentMethods')); i++) {
      // Do not upload the file if does not exists
      if (fileUploaded[i]) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }
    }

    return formData;
  };

  const savePaymentLoad = handleSubmit2(async (data) => {
    let dataToPost = { ...data };
    dataToPost = loadPaymentForms(dataToPost);
    membership?.payments?.push(...dataToPost?.payments);
    closePaymentModal();
  });

  const appendFileToEdit = (data) => {
    const formData = new FormData();
    formData.append('paymentType', paymentType);
    for (var i = 0; i < data?.payments.length; i++) {
      formData.append(`payments[${i}][amount]`, data?.payments[i].totalAmount);
      formData.append(
        `payments[${i}][amountBsS]`,
        data?.payments[i].totalAmount * dollarRate
      );

      if (data?.payments[i]?.bank) {
        formData.append(`payments[${i}][bank]`, data?.payments[i]?.bank);
      }
      if (data?.payments[i]?.phone) {
        formData.append(`payments[${i}][phone]`, data?.payments[i]?.phone);
      }

      formData.append(
        `payments[${i}][hasEvidence]`,
        fileUploaded[i] ? true : false
      );
      if (data?.payments[i]?.igtf && returnIGTF() > 0) {
        formData.append(`payments[${i}][igtf]`, data?.payments[i]?.igtf);
      }
      formData.append(
        `payments[${i}][method]`,
        data?.payments[i]?.methodId
          ? data?.payments[i]?.methodId
          : data?.payments[i]?.method
      );
      formData.append(`payments[${i}][reference]`, data?.payments[i].reference);
      if (
        data?.payments[i]?.transactionBatch !== undefined &&
        data?.payments[i]?.transactionBatch !== ''
      ) {
        formData.append(
          `payments[${i}][transactionBatch]`,
          data?.payments[i]?.transactionBatch
        );
      }

      if (
        isPaymentMethodZelleOrPaypal(
          data?.payments[i]?.methodId,
          paymentMethods
        )
      ) {
        // for zelle payments
        formData.append(
          `payments[${i}][accHolder]`,
          data?.payments[i]?.accHolder
        );
      }
      if (data?.payments[i]?._id) {
        formData.append(`payments[${i}][id]`, data?.payments[i]?._id);
      }
    }

    if (data?.referenceCashea) {
      formData.append('referenceCashea', data?.referenceCashea);
    }

    // Load as many files as payment methods we have
    if (
      fileUploaded.length !== parseFloat(watch2('paymentMethods')) &&
      parseFloat(watch2('paymentMethods')) > 0 &&
      MethodValidation(data?.payments, fileUploaded, paymentMethods)
    ) {
      notify('Ingrese comprobantes de pago', 'info');
      return null;
    }
    if (parseFloat(watch2('price'))) {
      let totalSum = 0;
      for (let i = 0; i < data?.payments.length; i++) {
        totalSum = totalSum + parseFloat(data?.payments[i].amount);
      }
      if (totalSum < parseFloat(watch2('price'))) {
        notify(
          'Monto a pagar por el cliente y suma de los pagos no coinciden',
          'info'
        );
        return null;
      }
    }

    if (['Cashea', 'Financiado'].includes(paymentType)) {
      if (membership.payments.length > 0) {
        formData.append(
          `paymentDues[${0}][amount]`,
          parseFloat(data?.payments[0]?.totalAmount)
        );
        formData.append(
          `paymentDues[${0}][date]`,
          data?.payments[0]?.createdAt
            ? data?.payments[0]?.createdAt
            : data?.payments[0].date
        );
      }

      for (let i = 0; i < data?.paymentDues.length; i++) {
        //* FALTA LA LOGICA PARA COLOCAR LA PRIMERA PAYMENT DUE COMO PAGADA
        formData.append(
          `paymentDues[${i + 1}][amount]`,
          parseFloat(data?.paymentDues[i].amount)
        );
        formData.append(
          `paymentDues[${i + 1}][date]`,
          data?.paymentDues[i].date
        );
      }
    }

    for (let i = 0; i < parseInt(watch2('paymentMethods')); i++) {
      // Do not upload the file if does not exists
      if (fileUploaded[i]) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }
    }
    return formData;
  };

  const editPaymentType = handleSubmit5(async (data) => {
    let dataToPost = { ...data };

    let paymentDues = [];

    if (['Cashea', 'Financiado'].includes(paymentType)) {
      let duesLength =
        paymentType === 'Cashea'
          ? watch5('duesQuantity')
            ? watch5('duesQuantity') - 1
            : paymentType === 'Financiado'
              ? 0
              : null
          : 0;

      for (let i = 0; i <= duesLength; i++) {
        let paymentDue = {};

        paymentDue.amount = dataToPost[`paymentDuesAmount` + i.toString()];
        paymentDue.date = dataToPost[`paymentDuesDate` + i.toString()];
        if (paymentDue?.date) {
          paymentDue.date = new Date(paymentDue.date).toISOString();
        }

        paymentDues.push({
          ...paymentDue,
        });
      }
      if (data?.referenceCashea) {
        membership.referenceCashea = data?.referenceCashea;
      }
    }

    membership.paymentDues = paymentDues;
    const formData = appendFileToEdit(membership);
    membershipService
      .editPaymentType(membership?._id, formData)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Metodo de pago actualizado`, 'success');
          reloadMembership();

          setTimeout(() => {
            history.push(`/afiliations/edit-order/${membership._id}`);
          }, 3000);
          setIsLoading(false);
        } else {
          notify(`${response.message}`, 'error');
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  });

  const preloadForm = () => {
    setValue('oldPaymentType', membership?.paymentType);
    setValue2('paymentType', paymentType);
    setValue('paymentType', paymentType);
    setValue5('paymentType', paymentType);

    setValue('priceInfo', membership?.priceInfo?.finalPrice?.toFixed(2));
    setValue2('price', getDuefromSuccessPayments(membership));
    setValue5('finalPrice', getDuefromSuccessPayments(membership));

    if (paymentType === 'Cashea') {
      const total = Number(watch5('finalPrice')) || 0;
      const dues = Number(watch5('duesQuantity')) || 3;
      const base = +(total / dues).toFixed(2);
      let sum = 0;

      for (let i = 0; i < dues; i++) {
        setValue5(
          `paymentDuesDate${i}`,
          new Date(
            new Date(membership?.createdAt).setDate(
              new Date(membership?.createdAt).getDate() + 14 * (i + 1)
            )
          )
        );
        if (i < dues - 1) {
          setValue5(`paymentDuesAmount${i}`, base);
          sum += base;
        } else {
          // La última cuota ajusta la diferencia
          const last = +(total - sum).toFixed(2);
          setValue5(`paymentDuesAmount${i}`, last);
        }
      }
    }

    if (paymentType === 'Financiado') {
      setValue5(
        `paymentDuesDate${0}`,
        new Date(
          new Date(membership?.createdAt).setDate(
            new Date(membership?.createdAt).getDate() + 30
          )
        )
      );

      setValue5('paymentDuesAmount0', getDuefromSuccessPayments(membership));
    }
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const closePaymentModal = () => {
    setOpenPayModal(false);
    setFileUploaded([]);
    reset2();
  };

  const handleAmountChange = (e, index) => {
    const { value } = e?.target;

    setValue2(`amountBsS${index}`, (value * dollarRate)?.toFixed(2));

    if (watch2('paymentType') === paymentType) {
      let price = parseFloat(watch2('price'));

      let amount2 = price - NaNtoNumber(parseFloat(watch2(`amount1`)));

      let quota2USD = price - amount2;
      if (amount2 <= 0) {
        setValue2('amount1', '');
        setValue2('amountBsS1', '');
        notify('Ingrese un monto valido para el pago', 'info');
      } else {
        setValue2('amount2', amount2);
        setValue2('amountBsS2', amount2 * dollarRate);
      }

      if (quota2USD < 0) {
        setValue2('amount1', '');
        setValue2('amountBsS1', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }
  };

  const editPayment = handleSubmit4(async (data) => {
    const formData = new FormData();
    formData.append('membership', membership?._id);
    formData.append(`payments[0][id]`, openEditPaymentModal?.payment?._id);
    formData.append(`payments[0][method]`, watch4(`method`));
    formData.append(`payments[0][reference]`, watch4(`reference`));
    if (watch4(`transactionBatch`) !== '' && watch4(`transactionBatch`) !== undefined) {
      formData.append(`payments[0][transactionBatch]`, watch4(`transactionBatch`));
    }
    formData.append(`payments[0][amount]`, watch4(`amount`));
    formData.append(`payments[0][amountBsS]`, watch4(`amountBsS`));
    formData.append(
      `payments[0][creationDate]`,
      moment(creationDate)?.format('YYYY-MM-DD')
    );
    if (watch4('bank')) {
      formData.append(`payments[0][bank]`, watch4(`bank`));
    }
    if (watch4(`phone`)) {
      formData.append(`payments[0][phone]`, watch4(`phone`));
    }
    if (membership?.paymentType === 'Cashea') {
      formData.append(
        `payments[0][referenceCashea]`,
        watch4(`referenceCashea`)
      );
    }

    if (!isLoading && formData) {
      setIsLoading(true);
      paymentsService
        .editPayment(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago editado con exito`, 'success');
            handleEditPaymentModal();
            reloadMembership();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const handlePaymentMethodsChange = () => {
    if (parseFloat(watch2('paymentMethods')) === 2) {
      setValue2('mix', true);
      setValue2('method1', '');
      setValue2('amount1', '');
      setValue2('amountBsS1', '');
      setValue2('method2', '');
      setValue2('amount2', '');
      setValue2('amountBsS2', '');
    } else {
      setValue2('mix', false);
    }
  };

  const handleSecondAmountChange = (e, index) => {
    let method = paymentMethods?.filter(
      (o) => o?._id === watch2(`method${index}`)
    )[0];

    if (method && method?.currency !== 'BsS' && watch2('mix')) {
      setValue2(
        'amount2IGTF',
        ((watch2('amount2') * returnIGTF()) / 100)?.toFixed(2)
      );
    }

    setValue2('amountBsS2', (watch2('amount2') * dollarRate)?.toFixed(2));

    if (watch2('paymentType') === 'Cuenta por cobrar') {
      let quota2USD = parseFloat(watch2('price'));

      if (watch2('paymentMethods') > 1) {
        let amount1 = quota2USD - NaNtoNumber(parseFloat(watch2(`amount2`)));
        if (amount1 > 0 && amount1 < parseFloat(watch2('price'))) {
          setValue2('amount1', amount1);
          setValue2('amountBsS1', (watch2(`amount1`) * dollarRate)?.toFixed(2));
        }
      }

      for (let i = 0; i < parseFloat(watch2('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch2(`amount${i + 1}`)));
      }

      if (
        NaNtoNumber(parseFloat(watch2(`amount2`))) > parseFloat(watch2('price'))
      ) {
        notify('El montos excede el costo de la membresia', 'info');
        setValue2('amount2', '');
        setValue2('amountBsS2', '');
        return null;
      }

      if (quota2USD >= 0) {
        setValue2('quota2USD', quota2USD);
        setValue2('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue2(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch2('price'))) - 1
        );
        setValue2('quota2USD', 0);
        setValue2('quota2BsS', 0);
        setValue2('amount1', '');
        setValue2('amountBsS1', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }

    if (watch2('paymentType') === 'De contado') {
      let quota2USD = parseFloat(watch2('price'));

      for (let i = 0; i < parseFloat(watch2('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch2(`amount${i + 1}`)));
      }

      if (quota2USD >= 0) {
        setValue2('quota2USD', quota2USD);
        setValue2('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue2(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch2('price'))) - 1
        );
        setValue2('quota2USD', 0);
        setValue2('quota2BsS', 0);
        setValue2('amount2', '');
        setValue2('amountBsS2', '');
        notify('La suma de los montos excede el costo de la membresia', 'info');
      }
    }

    if (
      watch2('paymentType') === 'Financiado' &&
      [paymentModalTypes?.RENOVACION]?.includes(watch2('modal'))
    ) {
      let quota2USD = parseFloat(watch2('price'));

      for (let i = 0; i < parseFloat(watch2('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch2(`amount${i + 1}`)));
      }

      if (quota2USD > 0) {
        setValue2('quota2USD', quota2USD);
        setValue2('quota2BsS', (quota2USD * dollarRate)?.toFixed(2));
      } else {
        setValue2(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch2('price'))) - 1
        );
        setValue2('amount2', '');
        setValue2('amountBsS2', '');
        notify('El monto de la segunda cuota debe ser mayor a 0$', 'info');
      }
    }

    if (
      watch2('paymentType') === 'Cuenta por cobrar' &&
      [paymentModalTypes?.PENDIENTE]?.includes(watch2('modal'))
    ) {
      let quota2USD = parseFloat(watch2('price'));

      for (let i = 0; i < parseFloat(watch2('paymentMethods')); i++) {
        quota2USD =
          quota2USD - NaNtoNumber(parseFloat(watch2(`amount${i + 1}`)));
      }

      if (quota2USD < 0) {
        setValue2(
          `amount${index}`,
          NaNtoNumber(parseFloat(watch2('price'))) - 1
        );
        setValue2('quota2USD', 0);
        setValue2('quota2BsS', 0);
        setValue2('amount2', '');
        setValue2('amountBsS2', '');
        notify('La suma de los montos supera el costo a facturar', 'info');
      }
    }
  };

  const restorePaymentMethods = () => {
    if (parseFloat(watch2('price')) === 0) {
      for (let i = 0; i < parseInt(watch2('paymentMethods')); i++) {
        resetField2(`method${i}`);
        resetField2(`reference${i}`);
        resetField2(`paymentMethod${i}`);
        resetField2(`amount${i}`);
        resetField2(`amountBsS${i}`);
      }
      resetField2('paymentMethods');
    }
    // setValue2()
  };

  const handlePaymentTypeForm = () => {
    // No logic nextWednesday, input blocked
  };

  const validateIfShowKM = () => {
    const [GOLD] = plansOptions?.filter((r) => r?.name === planTypes?.GOLD);
    if (GOLD?._id === watch('newCode')) {
      return true;
    } else {
      return false;
    }
  };

  const filterKMOptions = (options) => {
    if (membership?.membershipPlan === planTypes?.GOLD && !membership?.km) {
      let no150 = options.filter((r) => r?._id > 150);
      return no150;
    }

    if (membership?.km) {
      let aver = options.filter((r) => r?._id >= membership?.km);
      return aver;
    }
    return options;
  };

  useEffect(() => {
    setValue5('duesQuantity', 3);
  }, []);

  useEffect(() => {
    getPaymentMethods();
    preloadForm();
    getDollarRate();
  }, [open, membership, watch5('duesQuantity')]);

  return (
    <>
      <PaymentModal
        show={openPayModal}
        register={register2}
        openPayModal={openPayModal}
        handleClose={() => closePaymentModal()}
        payRewenMembership={savePaymentLoad}
        errors={errors2}
        control={control2}
        setValue={setValue2}
        options={{
          paymentMethods: paymentMethods,
          paymentTypesOptions: paymentTypesOptions,
          dollarRate: dollarRate,
        }}
        onChange={{
          handlePaymentTypeForm: handlePaymentTypeForm,
          restorePaymentMethods: restorePaymentMethods,
          handleAmountChange: handleAmountChange,
          handleSecondAmountChange: handleSecondAmountChange,
          handlePaymentMethodsChange: handlePaymentMethodsChange,
        }}
        watch={watch2}
        setFileUploaded={setFileUploaded}
        fileUploaded={fileUploaded}
        bsDisabled={bsDisabled}
      />

      <EditPaymentModal
        modal={openEditPaymentModal}
        register={register4}
        openPayModal={openPayModal}
        action={editPayment}
        handleClose={() => handleEditPaymentModal()}
        // payRewenMembership={Paymentaction()}
        paymentType={membership?.paymentType}
        errors={errors4}
        setValue={setValue4}
        control={control4}
        options={{
          paymentMethods: paymentMethods,
          paymentTypesOptions: paymentTypesOptions,
          dollarRate: dollarRate,
        }}
        creationDate={creationDate}
        onChange={{
          handleEditAmountChange: handleEditAmountChange,
          handleDateChange: handleDateChange,
        }}
        watch={watch4}
      />

      <div className="order-card">
        <OderCardHeader open={open} setOpen={setOpen} label={label} />

        {open && (
          <>
            <br />
            <div style={{ width: '100%' }} className="row">
              <div className="col-12">
                <div className="row">
                  <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    DATOS DEL CLIENTE
                  </h6>
                  <Input
                    bootstrap={'col-12 col-md-3'}
                    label={'Tipo de pago actual'}
                    type={'text'}
                    name={'oldPaymentType'}
                    register={register}
                    placeholder={''}
                    errors={errors?.oldPaymentType?.message}
                    disabled={true}
                  />
                  <Input
                    bootstrap={'col-12 col-md-3'}
                    label={'Tipo de pago nuevo'}
                    type={'text'}
                    name={'paymentType'}
                    register={register}
                    placeholder={''}
                    errors={errors?.paymentType?.message}
                    disabled={true}
                  />
                  <Input
                    bootstrap={'col-12 col-md-3'}
                    label={'Facturación del plan'}
                    type={'number'}
                    name={'priceInfo'}
                    register={register}
                    placeholder={''}
                    errors={errors?.priceInfo?.message}
                    disabled={true}
                  />
                </div>
                <div style={{ marginTop: '36px' }} className="row">
                  <h5>RESUMEN DE PAGO</h5>
                </div>
                <PaymentsTable
                  role={authService?.getUserType()}
                  header={
                    membership?.paymentType === paymentType?.CASHEA
                      ? casheaPaymentsTableHeader
                      : paymentsTableHeader
                  }
                  membership={membership}
                  handleEditPaymentModal={handleEditPaymentModal}
                />
              </div>
            </div>
          </>
        )}

        {['De contado'].includes(paymentType) && (
          <ActionButton
            label={'Agregar Pago'}
            action={() => {
              setOpenPayModal(true);
            }}
          />
        )}

        {/* This section should be conditional on payments being of Cashea type.*/}
        {paymentType === 'Cashea' && (
          <div style={{ width: '100%' }} className="row">
            <div className="col-12">
              <div className="row">
                <h6 style={{ margin: '6px 12px 12px 0px' }}>DATOS DE CASHEA</h6>
                {totalPrice > finalPrice ? (
                  <p
                    style={{
                      color: 'red',
                      fontSize: '14px',
                      width: '100%',
                    }}
                  >
                    La suma de los montos no debe exceder el valor permitido
                  </p>
                ) : totalPrice < finalPrice ? (
                  <p
                    style={{
                      color: 'red',
                      fontSize: '14px',
                      width: '100%',
                    }}
                  >
                    La suma de los montos no debe ser menor al valor permitido
                  </p>
                ) : errors5?.finalPrice?.message ? (
                  <p
                    style={{
                      color: 'red',
                      fontSize: '14px',
                      width: '100%',
                    }}
                  >
                    {errors5?.finalPrice.message}
                  </p>
                ) : null}
                <Input
                  bootstrap={'col-12 col-md-3'}
                  label={'Monto Deuda'}
                  type={'number'}
                  name={'finalPrice'}
                  register={register5}
                  placeholder={''}
                  errors={errors5?.finalPrice?.message}
                  disabled={true}
                />
                <Input
                  bootstrap={'col-12 col-md-2'}
                  label={'Número de cuotas'}
                  type={'select'}
                  options={[
                    { name: '3', id: 3 },
                    { name: '6', id: 6 },
                  ]}
                  name={'duesQuantity'}
                  register={register5}
                  placeholder={''}
                  errors={errors5?.referenceCashea?.message}
                />
                <Input
                  bootstrap={'col-12 col-md-2'}
                  label={'Referencia Cashea'}
                  type={'text'}
                  name={'referenceCashea'}
                  register={register5}
                  placeholder={''}
                  errors={errors5?.referenceCashea?.message}
                />
              </div>
              <div className="row">
                {Array.from({ length: watch5('duesQuantity') }).map((_, i) => (
                  <React.Fragment key={i}>
                    <Input
                      bootstrap={'col-12 col-md-3'}
                      label={`Monto Cuota ${i + 1}`}
                      type={'number'}
                      name={`paymentDuesAmount${i}`}
                      register={register5}
                      placeholder={''}
                      errors={errors5?.[`paymentDuesAmount${i}`]?.message}
                      disabled={
                        watch5('duesQuantity') === 3 ? i === 2 : i === 5
                      }
                      control={control5}
                      onChange={() => handleInputChange(i)}
                    />
                    <Input
                      bootstrap={'col-12 col-md-3'}
                      label={`Fecha de vencimiento cuota ${i + 1}`}
                      type={'date'}
                      name={`paymentDuesDate${i}`}
                      register={register5}
                      control={control5}
                      placeholder={''}
                      errors={errors5?.[`paymentDuesDate${i}`]?.message}
                    />
                    <div className="col-6"></div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}
        {paymentType === 'Financiado' && (
          <div style={{ width: '100%', marginTop: '2%' }} className="row">
            <Input
              bootstrap={'col-12 col-md-3'}
              label={'Monto Deuda'}
              type={'number'}
              name={'paymentDuesAmount0'}
              register={register5}
              control={control5}
              placeholder={''}
              errors={errors5?.paymentDuesAmount?.message}
              disabled={true}
            />
            <Input
              bootstrap={'col-12 col-md-3'}
              label={`Fecha de vencimiento`}
              type={'date'}
              name={`paymentDuesDate0`}
              register={register5}
              control={control5}
              placeholder={''}
              errors={errors5?.[`paymentDueDate`]?.message}
            />
            <div className="col-6"></div>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            margin: '2% auto',
          }}
        >
          <ActionButton label={'Guardar'} action={editPaymentType} />
        </div>
      </div>
    </>
  );
};
